const funcion6 = {
    titulo: `Función: retorno de un array`,
    problemas: [
      {
        codigo:1,
        descripcion: `Hemos visto que una función puede retornar un valor numérico, string o boolean. También una función puede retornar un arreglo.`,
programa: `function retornarArreglo() {
  const arreglo=[]
  for (let i = 0; i < 5; i++) {
    arreglo.push(i)
  }
  return arreglo
}

const arreglo1=retornarArreglo()
console.log(arreglo1)`,
        solucion: "[0, 1, 2, 3, 4]"
      },{
        codigo:2,
        descripcion: ``,
programa: `function retornarCopia(arreglo) {
  const copia = []
  for (let i = 0; i < arreglo.length; i++) {
    copia[i] = arreglo[i]
  }
  return copia
}

const arreglo1=new Array(5).fill(100)
const arreglo2=retornarCopia(arreglo1)
console.log(arreglo2)`,
        solucion: "[100, 100, 100, 100, 100]"
      },{
        codigo:3,
        descripcion: `Una función si tiene que retornar el mayor y menor valor de un arreglo, puede retornar un arreglo con dos elementos con el mayor y menor.`,
programa: `function retornarMayorMenor(arreglo) {
  let mayor = arreglo[0]
  for (let i = 1; i < arreglo.length; i++) {
    if (arreglo[i] > mayor) {
      mayor = arreglo[i]
    }
  }
  let menor = arreglo[0]
  for (let i = 1; i < arreglo.length; i++) {
    if (arreglo[i] < menor) {
      menor = arreglo[i]
    }
  }
  return [mayor, menor]
}

const arreglo = [100, 56, 200, 60, 5, 700]
const resultado = retornarMayorMenor(arreglo)
console.log(resultado)`,
        solucion: "[700, 5]"
      },{
        codigo:4,
        descripcion: ``,
programa: `function concatenar(arreglo1, arreglo2) {
  const nuevo = []
  for (let i = 0; i < arreglo1.length; i++) {
    nuevo.push(arreglo1[i])
  }
  for (let i = 0; i < arreglo2.length; i++) {
    nuevo.push(arreglo2[i])
  }
  return nuevo
}

const arreglo1 = [1, 2, 3, 4, 5]
const arreglo2 = [6, 7, 8, 9, 10]
const suma = concatenar(arreglo1, arreglo2)
console.log(suma)`,
        solucion: "[1, 2, 3, 4, 5, 6, 7, 8, 9, 10]"
      }
    ]
  }

export default funcion6;